import { useEffect } from 'react';
import type { PendingMessage } from '../types';
import { useSendChatMessage } from './useSendChatMessage';

type P = {
  chatroomId: string;
  onPendingMessageConsumed: () => void;
  pendingMessage?: PendingMessage;
};

export const useSendPendingChatMessageUseEffect = ({ chatroomId, onPendingMessageConsumed, pendingMessage }: P) => {
  const { sendChatMessage } = useSendChatMessage();

  useEffect(() => {
    if (!pendingMessage) {
      return;
    }

    sendChatMessage({
      attachments: pendingMessage.attachments,
      chatroomId,
      messageText: pendingMessage.message,
    });
    onPendingMessageConsumed();
  }, [chatroomId, onPendingMessageConsumed, pendingMessage, sendChatMessage]);
};
